import { Component } from 'react';

import { BraxToggleField, BraxToggleFieldProps } from '../BraxToggleField';

export type BraxSwitchFieldProps = Omit<BraxToggleFieldProps, 'type'>;

export class BraxSwitchField extends Component<BraxSwitchFieldProps> {

    render() {
        return (
            <div className="brax-switch">
                <BraxToggleField type="switch" {...this.props} />
            </div>
        );
    }

}
